import React from 'react';
import '@/App.css';
import {BrowserRouter, Routes, Route} from "react-router-dom";

import Error from '@/components/errors/Error';

import Layout from '@/pages/public/Layout';
import Accueil from '@/pages/public/accueil/Accueil';
import AdherentsRouter from '@/pages/prive/adherents/AdherentsRouter'
import LoginRouter from '@/pages/public/login/LoginRouter';
import Contact from '@/pages/public/contact/Contact';

import AR_router from '@/pages/public/AR/AR_router';
import MajDocumentation from '@/pages/prive/MajDocumentation';
import Documentation from '@/pages/prive/Documentation';
import Test from '@/pages/prive/Test';

import MailRouter from '@/pages/prive/mail/MailRouter';
import { accountService } from './_services/account.service';

function App() {
  
  return (
    <div>
      <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index='/'  element={<AdherentsRouter />} />
          
          <Route path='/accueil' element={<Accueil />} />
          <Route path='/contact' element={<Contact />} />

          <Route path='/adherents/*' element={<AdherentsRouter />} />
          <Route path='/login/*'  element={<LoginRouter />} />

          <Route path='/messagerie/*' element={<MailRouter />} />
          
          <Route path='/documentation' element={<Documentation />} />
          <Route path='/majDocumentation' element={<MajDocumentation />}/>
          <Route path='/AR/:ar' element={<AR_router />} />
          <Route path='/test' element={<Test />}/>
          <Route path='*' element={<Error type='404'>la page n'existe pas</Error>} />
        </Route>

      </Routes>
      </BrowserRouter>
    </div>

    );
}

export default App;
